const delay = async (ms: number) =>
	new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export default delay;
